export default {
    USER: state => {        
        return  state.user;
    }, 

    //CATEGORY
    CATEGORY_DESCRIPTION: state => {
        return state.categoryDescription;
    },

    CATEGORY_IMAGES: state => {
        return state.categoryImages;
    },
    //END CATEGORY

    //HTML EDITOR
    INIT_HTML_EDITOR: state => {
        return state.htmlEditEntity;
    },
    //END HTML EDITOR

    //ARTICLE
    ARTICLE_DESCRIPTION: state => {
        return state.articleDescription;
    },
    //END ARTICLE

    //COMMENT
    COMMENT_DESCRIPTION: state => {
        return state.commentDescription;
    },
    //END COMMENT

    //LANGUAGE ENTITY
    LANGUAGE_ENTITY: state => {
        return state.languageEntity;
    },
    //END LANGUAGE ENTITY 

    //SITE DATA
    SITE_DATA: (state) => {        
        return state.siteData;
    },
    //END SITE DATA

    //SOURCE JSON
    SOURCE_JSON: (state) => {
        return state.sourceJson;
    },
    //SOURCE JSON

    //CURRENT LANGUAGE
    CURRENT_LANGUAGE: (state) => {
        return state.selectedLanguage;
    }
    //CURRENT LANGUAGE

    
}